import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

export const getCampaignSubsellerNominations = prop(NAME);

export const getCampaignSubsellerNominationsFilter = createSelector(
	getCampaignSubsellerNominations,
	(nominations) => nominations.filter || {},
);

export const getCampaignSubsellerNominationsInitialOrgStructure = createSelector(
	getCampaignSubsellerNominations,
	propOr(EMPTY_VALUES.OBJECT, 'initialOrgStructure'),
);
